import React from 'react';
import styles from './actionButton.module.scss';

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  className?: string;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  isLoading,
  className = '',
  disabled,
  ...props
}) => {
  return (
    <button
      className={`${styles.actionBtn} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className={styles.loadingDots}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      ) : (
        children
      )}
    </button>
  );
};
